import { gql } from "@apollo/client";

export const GTM_PROJECT_CREATE_COMPONENT = gql`
  mutation GTM_PROJECT_CREATE_COMPONENT(
    $name: String!
    $number: String!
    $supplierId: ID!
    $moq: Int!
    $prices: [GTMProjectCreateComponentPriceInputType]!
    $gtmProjectId: ID!
    $gtmProjectComponentId: String!
    $gtmProjectComponentName: String!
    $syncToOdoo: Boolean
    $nameCn: String
  ) {
    gtmProjectCreateComponent(
      name: $name
      number: $number
      supplierId: $supplierId
      moq: $moq
      prices: $prices
      gtmProjectId: $gtmProjectId
      gtmProjectComponentId: $gtmProjectComponentId
      gtmProjectComponentName: $gtmProjectComponentName
      syncToOdoo: $syncToOdoo
      nameCn: $nameCn
    ) {
      product {
        id
      }
    }
  }
`;

export const GTM_PROJECT_CREATE_PRODUCT_LINE = gql`
  mutation GTM_PROJECT_CREATE_PRODUCT_LINE(
    $simpleFields: ProductLineSimpleFields
  ) {
    saveProductLine(simpleFields: $simpleFields) {
      productLine {
        id
        name
      }
    }
  }
`;

export const GTM_PROJECT_CREATE_PRODUCT_FOR_SALE = gql`
  mutation GTM_PROJECT_CREATE_PRODUCT_FOR_SALE(
    $gtmProjectId: ID!
    $gtmProjectPackagingId: String!
    $company: String!
    $name: String!
    $number: String!
    $nameCn: String
    $productLineId: ID
    $itemsPerSet: Int
    $packing: String
    $packingName: String
    $defaultQty: Int
    $outerCartonBarcodeEan: String
    $outerCartonBarcodeUpc: String
    $innerCartonBarcodeEan: String
    $innerCartonBarcodeUpc: String
    $innerBoxBarcodeEan: String
    $innerBoxBarcodeUpc: String
    $innerBoxBarcodeJd: String
    $outerCartonBarcodeJd: String
    $cccInfo: String
    $colors: String
    $itemWeight: Float
    $grossWeight: Float
    $outerCartonX: Float
    $outerCartonY: Float
    $outerCartonZ: Float
    $ctnNetWeight: Float
    $reminderForMissingBeautyShot: String
    $shippingMarkName: String
    $bomLines: [GTMProjectCreateBomLineInputType]
    $oneDriveImageIds: [String]
  ) {
    gtmProjectCreateProductForSale(
      gtmProjectId: $gtmProjectId
      gtmProjectPackagingId: $gtmProjectPackagingId

      company: $company
      name: $name
      nameCn: $nameCn
      number: $number
      productLineId: $productLineId
      defaultQty: $defaultQty
      itemsPerSet: $itemsPerSet
      bomLines: $bomLines

      packing: $packing
      packingName: $packingName
      shippingMarkName: $shippingMarkName

      outerCartonBarcodeEan: $outerCartonBarcodeEan
      outerCartonBarcodeUpc: $outerCartonBarcodeUpc
      innerCartonBarcodeEan: $innerCartonBarcodeEan
      innerCartonBarcodeUpc: $innerCartonBarcodeUpc
      innerBoxBarcodeEan: $innerBoxBarcodeEan
      innerBoxBarcodeUpc: $innerBoxBarcodeUpc
      innerBoxBarcodeJd: $innerBoxBarcodeJd
      outerCartonBarcodeJd: $outerCartonBarcodeJd
      cccInfo: $cccInfo
      colors: $colors

      itemWeight: $itemWeight
      grossWeight: $grossWeight
      outerCartonX: $outerCartonX
      outerCartonY: $outerCartonY
      outerCartonZ: $outerCartonZ
      ctnNetWeight: $ctnNetWeight

      oneDriveImageIds: $oneDriveImageIds
      reminderForMissingBeautyShot: $reminderForMissingBeautyShot
    ) {
      product {
        id
      }
    }
  }
`;
